<p-toast></p-toast>
<div id="iframe-portalV1" style="height: auto">
  <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
    <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
      <ol class="breadcrumb ol-sf-1">
        <li class="breadcrumb-item">
          <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent()?.company.uniqid}}">Home</a>
          <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent()?.company.uniqid}}">Home</a>
        </li>
        <li aria-current="page" class="breadcrumb-item active">
          Weather map {{ region }}
        </li>
      </ol>
    </nav>
  </nav>
</div>
<div class="region-buttons mb-4 button-section">
  <button (click)="selectRegion('us')" [disabled]="region === 'us'" class="icon map">
    <span style="color:RoyalBlue"> US </span>
  </button>
  <button (click)="selectRegion('toronto')" [disabled]="region === 'toronto'" class="icon map">
    <span style="color:DarkGreen"> Toronto </span>
  </button>
  <button (click)="selectRegion('london')" [disabled]="region === 'london'" class="icon map">
    <span style="color:DarkOrchid"> London </span>
  </button>
  <button (click)="selectRegion('eu')" [disabled]="region === 'eu'" class="icon map">
    <span style="color:DarkRed"> EU </span>
  </button>
  <button (click)="selectRegion('tokyo')" [disabled]="region === 'tokyo'" class="icon map">
    Tokyo
  </button>

</div>

<div id="windy" style="width: 95%; height: 83%;"></div>

<div class="weather-disclaimer">
  <h6>Disclaimer: Weather Map Information</h6>
  <p>
    The weather map provided on this page, sourced from Windy.com, is primarily focused on depicting precipitation and wind patterns.
    While we suggest precipitation as one of the key elements that impacts radio signals, this map may not capture ALL the nuances of microclimates that may impact radio signals.
    Additionally, note that the displayed radio paths are geographically indicative and should not be considered absolute.
  </p>
</div>



